import React from 'react';

const DOMAIN_META = {
  api: { label: 'Airports', color: '#2563EB', bg: '#DBEAFE', border: '#93C5FD' },
  ias: { label: 'Aviation Services', color: '#0284C7', bg: '#E0F2FE', border: '#7DD3FC' },
  twc: { label: 'Destination', color: '#9333EA', bg: '#F3E8FF', border: '#D8B4FE' },
  hin: { label: 'Hospitality', color: '#7C3AED', bg: '#EDE9FE', border: '#C4B5FD' },
  itdc: { label: 'Tourism Development', color: '#16A34A', bg: '#DCFCE7', border: '#86EFAC' },
  retail: { label: 'Retail', color: '#059669', bg: '#D1FAE5', border: '#6EE7B7' },
  membership: { label: 'Membership', color: '#0F766E', bg: '#CCFBF1', border: '#5EEAD4' },
  concierge: { label: 'Concierge', color: '#C026D3', bg: '#FAE8FF', border: '#F0ABFC' },
};

const normalizeDomain = (value = '') => value.toString().trim().toLowerCase();

const DomainBadge = ({ domain, label }) => {
  const key = normalizeDomain(domain);
  const meta = DOMAIN_META[key] || {
    label: label || domain || 'Unknown domain',
    color: '#64748B',
    bg: '#F1F5F9',
    border: '#CBD5E1',
  };

  return (
    <span
      className="inline-flex min-h-[28px] items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-bold leading-none text-label-primary"
      style={{ backgroundColor: meta.bg, borderColor: meta.border }}
    >
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: meta.color }} />
      {label || meta.label}
    </span>
  );
};

export default DomainBadge;
